import React from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";

import { MITIGATION_FACTOR_OPTIONS, asMitigationFactorArray } from "./utils";

export default function MitigationFactorSelect({
  value,
  onChange,
  labelId,
  testId,
  options = MITIGATION_FACTOR_OPTIONS,
}: {
  value: string[];
  onChange: (value: string[]) => void;
  labelId: string;
  testId?: string;
  options?: string[];
}) {
  const safeValue = asMitigationFactorArray(value);

  return (
    <Select
      multiple
      fullWidth
      style={{ background: "#F8F9FD" }}
      labelId={labelId}
      value={safeValue}
      onChange={(event: SelectChangeEvent<string[]>) => {
        const selected = event.target.value;
        onChange(typeof selected === "string" ? selected.split(",") : selected);
      }}
      renderValue={(selected) => asMitigationFactorArray(selected).join(", ")}
      MenuProps={{
        PaperProps: { style: { maxHeight: 300 } },
      }}
      data-testid={testId}
    >
      {options.map((option) => (
        <MenuItem
          key={option}
          value={option}
          dense
          sx={{ minHeight: "auto", paddingY: "2px" }}
        >
          <Checkbox
            checked={safeValue.includes(option)}
            size="small"
            sx={{ padding: "4px" }}
          />
          <ListItemText
            primary={option}
            primaryTypographyProps={{ noWrap: true }}
          />
        </MenuItem>
      ))}
    </Select>
  );
}
